import Produto from "@/domain/produtos/Produtos.js";
import Table from "./Table";
export default class TableProdutos extends Table {
    constructor() {
        super();
    }

    getHeaders() {
        var headers = [
            { text: "Ações", value: "acoes", show: false, pesq: false, enable: false},
            { text: "Nome do Produto", value: "xProd", show: true, pesq: true , enable: true},
            { text: "Código do Produto", value: "cProd", show: true, pesq: true , enable: true},
            { text: "NCM", value: "NCM", show: true, pesq: false , enable: true},
            { text: "Unidade", value: "uCom", show: true, pesq: false , enable: true},
            { text: "CNPJ Fornecedor", value: "fornCnpj", show: true, pesq: false , enable: true},
            { text: "Razão Social Fornecedor", value: "fornRazao", show: true, pesq: false , enable: true},
            // { text: "Data de inclusão", value: "dtInclusao", width: "500px", show: true, pesq: false , enable: true},
            // { text: "Lote/Vencimento", value: "prodRastro", show: true, pesq: false , enable: true},
            { text: "Data da inclusão", value: "dtReg", width: "500px", show: false, pesq: false, enable: true},
            { text: "CFOP", value: "CFOP", show: false, pesq: false , enable: false},
            { text: "cEAN", value: "cEAN", show: false, pesq: false , enable: false},
            { text: "conta", value: "conta", show: false, pesq: false , enable: false},
            { text: "fornId", value: "fornId", show: false, pesq: false , enable: false},
            { text: "nfes", value: "nfes", show: false, pesq: false , enable: false},
            { text: "_id", value: "_id", show: false, pesq: false , enable: false},
            // { text: "customValues", value: "customValues", show: false, pesq: false , enable: true},
      
        ]
        return headers
    }

    setNota(arrayNotas, notas) {
        let newArray = arrayNotas;
        this.loading = false;
        for (var i = 0; i < notas.length; i++) {
            newArray.push(
                new Produto(
                    notas[i].prod._id,
                    notas[i].prod.xProd,
                    notas[i].prod.cProd,
                    notas[i].prod.NCM,
                    notas[i].prod.uCom,
                    notas[i].prod.CFOP,
                    notas[i].prod.cEAN,
                    notas[i].prodRastro,
                    notas[i].cpfCnpj,
                    notas[i].razao,
                    notas[i].prod.dtReg,
                    notas[i]._id,
                    notas[i].prod.customValues,
                    notas[i].prod.conta,
                    notas[i].prod.nfes
                )
            );

            this.pagination.sortBy = 'xProd';
            this.pagination.descending = false;
            // arrayNotas.sort(function (a, b) {
            //     return a.xProd < b.xProd ? -1 : a.xProd > b.xProd ? 1 : 0;
            // });

        }
        if(arrayNotas.length > 0) {
            arrayNotas = [ ...arrayNotas, ...newArray ];
            return arrayNotas;
        }else {
            return newArray;
        }
    }
}





// WEBPACK FOOTER //
// ./src/domain/dataTable/TableProdutos.js